
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exams",
      function () {
        return require("private-next-pages/exams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exams"])
      });
    }
  